import { c as _c } from "react/compiler-runtime";
import { Modal, ModalHeader, ModalBody, ModalFooter, ObjectSelector, Button, Stack } from '@newfront-insurance/core-ui';
import type { ReactNode, JSX } from 'react';
import { useEffect, useState } from 'react';
import type { Policy } from '../../bff/types';
import { useFuzzy } from '../../utils/hooks/use-fuzzy';
import { PolicyCard } from '../policy-card';
interface Props {
  isOpen: boolean;
  loading?: boolean;
  /** The error message to display */
  error?: string;
  onToggle: () => void;
  /** Array of Policies to display */
  policies: Policy[];
  /** Modal title */
  header: string;
  /** Function to define the text to show on the submit button. It receives the array of selected policies as a param */
  submitText: string | ((policyUuids: string[]) => ReactNode);
  /** If required, you will need at least one policy selected for Submit to become enabled */
  required?: boolean;
  onSubmit: (policyUuids: string[]) => void;
  submitting?: boolean;
  /** Multi will display checkboxes, single will display radio buttons */
  type: 'multi' | 'single';
  /** An array of IDs of the policies that are already selected */
  initialSelectedPoliciesUuids: string[];
}
export function PolicySelectorModal(t0) {
  const $ = _c(51);
  const {
    isOpen,
    onToggle,
    loading: t1,
    error,
    policies,
    type,
    header,
    submitText,
    submitting: t2,
    required: t3,
    onSubmit,
    initialSelectedPoliciesUuids
  } = t0;
  const loading = t1 === undefined ? false : t1;
  const submitting = t2 === undefined ? false : t2;
  const required = t3 === undefined ? false : t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      keys: ["type", "name", "policyNumber", "details.displayName", "carrier.name", "details.thirdParty"]
    };
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  const {
    result: results,
    search,
    keyword
  } = useFuzzy(policies, t4);
  const [selectedPoliciesUuids, setSelectedPoliciesUuids] = useState(initialSelectedPoliciesUuids);
  let t5;
  let t6;
  if ($[1] !== initialSelectedPoliciesUuids) {
    t5 = () => {
      setSelectedPoliciesUuids(initialSelectedPoliciesUuids);
    };
    t6 = [initialSelectedPoliciesUuids];
    $[1] = initialSelectedPoliciesUuids;
    $[2] = t5;
    $[3] = t6;
  } else {
    t5 = $[2];
    t6 = $[3];
  }
  useEffect(t5, t6);
  let t7;
  if ($[4] !== type) {
    t7 = function handleSelection(policy) {
      if (type === "multi") {
        setSelectedPoliciesUuids(currentSelectedPoliciesUuids => currentSelectedPoliciesUuids.includes(policy.uuid || "") ? currentSelectedPoliciesUuids.filter(policyUuid => policyUuid !== policy.uuid) : currentSelectedPoliciesUuids.concat([policy.uuid ?? ""]));
        return;
      }
      setSelectedPoliciesUuids([policy.uuid ?? ""]);
    };
    $[4] = type;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  const handleSelection = t7;
  let t8;
  if ($[6] !== selectedPoliciesUuids) {
    t8 = function isSelected(policy_0) {
      return selectedPoliciesUuids.includes(policy_0.uuid ?? "");
    };
    $[6] = selectedPoliciesUuids;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const isSelected = t8;
  let t9;
  if ($[8] !== onSubmit || $[9] !== selectedPoliciesUuids) {
    t9 = function handleSubmit() {
      onSubmit(selectedPoliciesUuids);
    };
    $[8] = onSubmit;
    $[9] = selectedPoliciesUuids;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const handleSubmit = t9;
  let t10;
  if ($[11] !== header || $[12] !== onToggle) {
    t10 = <ModalHeader titleText={header} onClose={onToggle} />;
    $[11] = header;
    $[12] = onToggle;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== handleSelection || $[15] !== isSelected || $[16] !== results || $[17] !== type) {
    let t12;
    if ($[19] !== handleSelection || $[20] !== isSelected || $[21] !== type) {
      t12 = policy_1 => <PolicyCard key={policy_1.uuid} policy={policy_1} onSelect={() => handleSelection(policy_1)} isSelected={isSelected(policy_1)} selectType={type === "multi" ? "checkbox" : "radio"} />;
      $[19] = handleSelection;
      $[20] = isSelected;
      $[21] = type;
      $[22] = t12;
    } else {
      t12 = $[22];
    }
    t11 = results.map(t12);
    $[14] = handleSelection;
    $[15] = isSelected;
    $[16] = results;
    $[17] = type;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[23] !== error || $[24] !== keyword || $[25] !== loading || $[26] !== search || $[27] !== t11) {
    t12 = <ObjectSelector loading={loading} error={error} placeholder="No policies available" onSearchInputChange={search} searchInput={keyword}>{t11}</ObjectSelector>;
    $[23] = error;
    $[24] = keyword;
    $[25] = loading;
    $[26] = search;
    $[27] = t11;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== onToggle || $[30] !== submitting) {
    t13 = <Button onClick={onToggle} disabled={submitting} size="secondary">Cancel</Button>;
    $[29] = onToggle;
    $[30] = submitting;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  const t14 = required ? selectedPoliciesUuids.length === 0 : false;
  let t15;
  if ($[32] !== selectedPoliciesUuids || $[33] !== submitText) {
    t15 = typeof submitText === "function" ? submitText(selectedPoliciesUuids) : submitText;
    $[32] = selectedPoliciesUuids;
    $[33] = submitText;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== handleSubmit || $[36] !== submitting || $[37] !== t14 || $[38] !== t15) {
    t16 = <Button loading={submitting} disabled={t14} onClick={handleSubmit}>{t15}</Button>;
    $[35] = handleSubmit;
    $[36] = submitting;
    $[37] = t14;
    $[38] = t15;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  let t17;
  if ($[40] !== t13 || $[41] !== t16) {
    t17 = <ModalFooter><Stack gap={8} direction="horizontal" justifyContent="flex-end">{t13}{t16}</Stack></ModalFooter>;
    $[40] = t13;
    $[41] = t16;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  let t18;
  if ($[43] !== t10 || $[44] !== t12 || $[45] !== t17) {
    t18 = <ModalBody>{t10}{t12}{t17}</ModalBody>;
    $[43] = t10;
    $[44] = t12;
    $[45] = t17;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  let t19;
  if ($[47] !== isOpen || $[48] !== onToggle || $[49] !== t18) {
    t19 = <Modal isOpen={isOpen} onToggle={onToggle} width="600px">{t18}</Modal>;
    $[47] = isOpen;
    $[48] = onToggle;
    $[49] = t18;
    $[50] = t19;
  } else {
    t19 = $[50];
  }
  return t19;
}